import MarkerWithLabel from 'markerwithlabel'

export default {
  props: {
    google: Object,
    map: Object,
    markerOptions: Object
  },
  data () {
    return {
      MarkerWithLabel: MarkerWithLabel(this.google.maps),
      marker: null
    }
  },
  mounted () {
    this.drawMarker()
  },
  destroyed () {
    if (this.marker) this.marker.setMap(null)
  },
  methods: {
    drawMarker () {
      this.marker = new this.MarkerWithLabel({
        map: this.map,
        ...this.markerOptions,
        markerOptions: this.markerOptions,
        labelClass: 'background: white'
      })
    }
  },
  render () {

  }
}
